import React from 'react';

import {RegistryLabelingStrategy} from 'constants/RegistryConstants';
import * as RegistryConstants from 'constants/RegistryConstants';
import {NameTemplatePart, NameTemplatePartType} from 'name-templates/NameTemplateConstants';
import Tooltip from 'ui-library/bs/Tooltip';
import WarningIcon from 'ui-library/icons/WarningIcon';

interface Props {
  labelingStrategies: Array<RegistryLabelingStrategy>;
  nameTemplateParts: Array<NameTemplatePart>;
  className?: string;
}

export default function LabelingStrategyWarning(props: Props): JSX.Element | null {
  const nameTemplatePartTypes = props.nameTemplateParts.map((part) => part.type);
  const nameTemplateHasRegIdPart =
    nameTemplatePartTypes.includes(NameTemplatePartType.REGISTRY_IDENTIFIER_NUMBER) ||
    nameTemplatePartTypes.includes(NameTemplatePartType.REGISTRY_IDENTIFIER_NUMBER_BASE_26);
  const shouldWarn =
    nameTemplateHasRegIdPart &&
    props.labelingStrategies.includes(RegistryLabelingStrategy.REPLACE_ID_AND_NAME_FROM_PARTS);

  return shouldWarn ? (
    <Tooltip
      title={`The naming option "${
        RegistryConstants.LABELING_STRATEGY_TO_TEXT[RegistryLabelingStrategy.REPLACE_ID_AND_NAME_FROM_PARTS]
      }" may not produce the desired names when "Registry ID Number" is used in the naming template`}
    >
      <WarningIcon className={props.className} />
    </Tooltip>
  ) : null;
}
